import { getAuthHeaders } from "@/api/auth"
import axiosUserAuthRequired from "@/api/axiosAuthRequired.js"
import { BASE_URL } from "@/constants/util"

export const generateAimlabsWebAuthCode = async () => {
  try {
    const url = `${BASE_URL}oauth/authorization-code/aimlabs-web`
    const config = {
      headers: getAuthHeaders(),
    }
    const response = await axiosUserAuthRequired.post(url, null, config)
    return response.data
  } catch (e) {
    console.error("Failed to generate authorization code for Aimlabs web", e)
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/store/aimlabs/discovery/discovery.apis.js